/**
 * Removes entries with empty string, null, or undefined values from a params object.
 * Useful for building clean query params for API calls.
 */
export const cleanParams = <T extends Record<string, unknown>>(
	params: T
): Partial<T> => {
	const cleaned = {} as Partial<T>

	Object.entries(params).forEach(([key, value]) => {
		if (value != null && value !== '') {
			;(cleaned as Record<string, unknown>)[key] = value
		}
	})

	return cleaned
}
